module.exports = __webpack_public_path__ + "static/media/linkedin.c843a8a2.svg";